import type {
  FetchedDownstreamHandlingTypes,
  FetchedWasteTypes,
} from "@/Utils/api/sanity/types";
import { getFlatDownstreamData } from "@/Utils/downstreamHandlingUtils";
import { sortByOrderRank } from "@/Utils/wasteStreams";
import type { WasteTypeConfig } from "@/pages/configuration/useConfigService";

import { uniq } from "lodash";

import type { WasteColumn } from "../../types";
import type { ActiveReportingData } from "./activeData";

export const getWasteColumns = (
  activeData: ActiveReportingData,
  sanityWasteTypes: FetchedWasteTypes | null,
  wasteTypeConfig: WasteTypeConfig[],
  downstreamHandling: FetchedDownstreamHandlingTypes | null,
): WasteColumn[] => {
  const sources = [
    ...(activeData.periods?.map((period) => period.source) ?? []),
    ...(activeData.terminals ?? []),
    ...(activeData.customers ?? []),
  ];

  if (!sanityWasteTypes) return [];

  const flatDownstreamData = getFlatDownstreamData(downstreamHandling || []);

  const codes = uniq(
    sources.flatMap((source) => source.wasteTypes.map((wt) => wt.code)),
  );

  return sortByOrderRank(codes, sanityWasteTypes)
    .map((code) => {
      const config = wasteTypeConfig.find((c) => c.wasteTypeCode === code);
      const label =
        config?.name ||
        sanityWasteTypes.find((swt) => swt.id === code)?.name ||
        "";
      return {
        code,
        label,
        downstreamHandlingId: config?.downstreamHandlingId ?? undefined,
        downstreamHandling: config?.downstreamHandlingId
          ? flatDownstreamData[config.downstreamHandlingId]
          : undefined,
      };
    })
    .filter((column) => !!column.label);
};
